import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { loadLanguageAsync } from '@/lang'
import axios from 'axios'
// transformRequest
import { transformRequest, session, cookie } from '@/utils/util'
// import { resolve } from 'path'
import { apiNovice } from '@api/noviceBag'
import AES from '@/utils/aes'

const user = {
  state: {
    token: '',
    lang: cookie.get('language') || 'zh_CN',
    hasLogin: false,
    userInfo: '{}',
    tenantNo: '', // 租户号
    tokenAvailable: true, // token是否可用
    isBuyBag: true, // 是否购买新手包 true：没购买
    isBeyondDay: true, // 用户的机器人或设计器是否有一个在30天内过期 true:有
    orderStatus: 0 // 判断用户是否有待支付订单 -1：没有
  },
  getters: {
    userInfo: state => state.userInfo,
    tenantNo: state => state.tenantNo,
    hasLogin: state => state.hasLogin,
    lang: state => state.lang,
    token: state => state.token,
    tokenAvailable: state => state.tokenAvailable,
    isBuyBag: state => state.isBuyBag,
    isBeyondDay: state => state.isBeyondDay,
    orderStatus: state => state.orderStatus
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      Vue.ls.set(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000)
    },
    SET_LANG: (state, lang) => {
      state.lang = lang
    },
    // 更新登录状态
    updateLoginStatus (state, status) {
      state.hasLogin = status
    },
    // 更新token可用的状态
    updateTokenAvailable (state, status) {
      state.tokenAvailable = status
    },
    // 更新用户信息
    updateUserInfo (state, info, token = Vue.prototype.$token.loadToken().access_token || '') {
      state.userInfo = info
      state.token = token
      // Vue.prototype.$cookies.set('is-rpa-user-info', AES.Encrypt(info))
      state.tenantNo = info.tenantNo
    },
    // 清除用户信息
    clearUserInfo (state) {
      state.userInfo = ''
    },
    // 更改新手包状态
    updateNoviceState (state, result) {
      state.isBuyBag = result.npStatus
      state.isBeyondDay = result.rsStatus
      state.orderStatus = result.orderStatus
    }
  },

  actions: {
    // 设置界面语言
    SetLang ({ commit }, lang) {
      return new Promise(async resolve => {
        // console.log(lang)
        commit('SET_LANG', lang)
        await loadLanguageAsync(lang)
        // console.log(Vue.$i18n.locale)
        // alert('111')
        // 设置国际化网页标题
        // document.title = window.$globalHub.$t('htmlTit')
        resolve()
      })
    },
    // 登录
    Login ({ commit }, userInfo) {
      // alert('前往统一登录界面')
      // 前往获取授权的统一登录界面
      // alert(JSON.stringify(Vue.prototype.$config))
      var authorUrl = Vue.prototype.$config.userAuthorizationUri
      var params = {
        client_id: Vue.prototype.$config.clientId,
        response_type: Vue.prototype.$config.response_type,
        scope: Vue.prototype.$config.scope,
        state: Vue.prototype.$config.state,
        redirect_uri: Vue.prototype.$config.redirecttoken_uri
      }
      // alert(transformRequest(params))
      authorUrl = authorUrl + ('?' + transformRequest(params))
      // alert(authorUrl)
      // 跳转到后台统一登录页
      // window.location.href = authorUrl
      return new Promise((resolve) => {
        resolve(authorUrl)
      })
    },
    // 获取登录用户信息
    getUserInfo ({ commit }, getInfoUrl) {
      return new Promise((resolve, reject) => {
        axios.get(getInfoUrl).then(res => {
          // debugger
          if (res.data.code === 0) {
            commit('updateUserInfo', JSON.stringify(res.data.result))
            commit('updateLoginStatus', true)
            resolve(res.data.result)
          } else {
            commit('updateUserInfo', '')
            // cookie.remove('is-rpa-user-info')
            // Vue.prototype.$cookies.remove('is-rpa-user-info')
            commit('updateLoginStatus', false)
          }
        }, err => {
          commit('updateLoginStatus', false)
          reject(err)
        }).catch(err => {
          commit('updateLoginStatus', false)
          reject(err)
        })
      })
    },
    // 检查Token是否过期
    checkToken ({ commit }, checkTokenUrl) {
      const token = Vue.prototype.$token.loadToken().access_token
      const accessToken = AES.Decrypt(Vue.prototype.$cookies.get('access_token'))
      if (token !== accessToken) {
        Vue.prototype.$token.savetoken({ access_token: accessToken })
        Vue.prototype.$cookies.set('access_token', accessToken)
      }
      return new Promise((resolve, reject) => {
        axios.post(checkTokenUrl).then(res => {
          if (!res) {
            commit('updateTokenAvailable', false)
          } else {
            commit('updateTokenAvailable', true)
          }
          resolve(res)
        }, err => {
          reject(err)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 退出
    LogOut ({ commit, state }, logOutUrl = {
      url: Vue.prototype.$config.logoutUri,
      access_token: Vue.prototype.$token.loadToken().access_token,
      callback: Vue.prototype.$config.localuri
    }) {
      return new Promise((resolve, reject) => {
        // 清空账号信息、登录状态
        commit('updateUserInfo', '')
        commit('updateLoginStatus', false)
        // 清除用户信息
        // Vue.prototype.$cookies.remove('is-rpa-user-info')
        // 删除JSESSIONID，停止前后台之间的会话
        Vue.prototype.$cookies.remove('JSESSIONID')
        // 清除token
        Vue.prototype.$token.deleteToken()
        // 清空session
        session.clear()
        // 清空storage
        Vue.ls.clear()
        // alert(logOutUrl.url)
        // 跳转到后台退出界面
        window.location.href = `${logOutUrl.url}?access_token=${logOutUrl.access_token}&callback=${logOutUrl.callback}`

        // axios.post(
        //   logOutUrl.url,
        //   transformRequest({ 'access_token': logOutUrl.access_token })
        // ).then(res => {
        //   resolve(res)
        // }, err => {
        //   reject(err)
        // }).catch(err => {
        //   reject(err)
        // })
      })
    },
    // 是否购买过新手包
    junpNovice ({ commit, state }) {
      return new Promise((resolve, reject) => {
        apiNovice(JSON.parse(state.userInfo).tenantNo).then(data => {
          commit('updateNoviceState', data)
          resolve()
        }).catch((err) => {
          commit('updateNoviceState', true)
          reject(err)
        })
      })
    }
  }
}

export default user
